/**
 * Order Services Module
 * Exports all order management services and factory functions
 */
// Service exports (1-to-1 controller mapping)
export * from './OrderService';
export * from './OrderLineService';
export * from './OrderLineAddOnService';
export * from './OrderLineVariantService';
export * from './OrderPaymentService';
// Progressive batched fetching for the heavy Store admin lists.
export * from './OrdersStreamingService';
export * from './OrderStatusService';
export * from './OrderLineStatusService';
export * from './PaymentStatusService';
export * from './OrderNotificationService';
export * from './OrderShopService';
// ModelView services — thin read-side wrappers over the /view routes.
// These existed as files but were never wired into the barrel, the factory or the
// hooks, so they were unreachable from consuming apps while their backend routes
// were live. Exported here so admin UIs can use them.
export * from './OrderModelViewService';
export * from './OrderLineModelViewService';
export * from './OrderPaymentModelViewService';
// Service imports for factory
import { OrderService } from './OrderService';
import { OrderLineService } from './OrderLineService';
import { OrderLineAddOnService } from './OrderLineAddOnService';
import { OrderLineVariantService } from './OrderLineVariantService';
import { OrderPaymentService } from './OrderPaymentService';
import { OrderStatusService } from './OrderStatusService';
import { OrderLineStatusService } from './OrderLineStatusService';
import { PaymentStatusService } from './PaymentStatusService';
import { OrderNotificationService } from './OrderNotificationService';
import { OrderShopService } from './OrderShopService';
import { OrderModelViewService } from './OrderModelViewService';
import { OrderLineModelViewService } from './OrderLineModelViewService';
import { OrderPaymentModelViewService } from './OrderPaymentModelViewService';
/**
 * Create all order services with shared configuration
 * @param http - HTTP client instance
 * @param config - Service configuration (servicePath, endpoints)
 * @returns Object containing all order service instances
 */
export function createOrderServices(http, config) {
    return {
        order: new OrderService(http, config),
        orderLine: new OrderLineService(http, config),
        orderLineAddOn: new OrderLineAddOnService(http, config),
        orderLineVariant: new OrderLineVariantService(http, config),
        orderPayment: new OrderPaymentService(http, config),
        orderStatus: new OrderStatusService(http, config),
        orderLineStatus: new OrderLineStatusService(http, config),
        paymentStatus: new PaymentStatusService(http, config),
        orderNotification: new OrderNotificationService(http, config),
        shop: new OrderShopService(http, config),
        orderModelView: new OrderModelViewService(http, config),
        orderLineModelView: new OrderLineModelViewService(http, config),
        orderPaymentModelView: new OrderPaymentModelViewService(http, config),
    };
}
//# sourceMappingURL=index.js.map